import {useEffect, useState, useRef} from "react";
import {getAllRecordedPayments, verifyPayment, invalidatePayment} from "../../api/Api";
import {Table, Row, Button, message} from 'antd';
import {toFSDateTime} from "../../util/timeutils";
import {getColumnSearchProps} from "../widget/SearchProps";
import {Link} from 'react-router';

export const RecordedPayment = ({onApiFail, refresh, onRefresh, props}) => {
    const [payments, setPayments] = useState([]);
    const [messageApi, contextHolder] = message.useMessage();

    useEffect(() => {
        getAllRecordedPayments().then(result => {
            setPayments(result.map(i => {
                return {...i,
                    key: i.id
                }
            }));
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }, [refresh, onApiFail]);


    // for use with search props
    const searchInput = useRef(null);

    const columns = [
        {
            title: 'Invoice',
            dataIndex: 'invoiceNumber',
            key: 'invoice',
            ...getColumnSearchProps(`invoiceNumber`, searchInput),
            sorter: (a, b) => a.invoiceNumber.toLowerCase().localeCompare(b.invoiceNumber.toLowerCase()),
            render: (val, record, index) => {
                return <Link to={`/invoice/${record.invoiceId}`}>{val}</Link>
            }
        },
        {
            title: 'Customer',
            dataIndex: 'firstname',
            key: 'customer',
            render: (val, record, index) => {
                return <div>
                    <Row>{`${record.firstname} ${record.lastname}`}</Row>
                    <Row>{`${record.company}`}</Row>
                </div>
            },
            ...getColumnSearchProps(`firstname`, searchInput),
            sorter: (a, b) => a.firstname.toLowerCase().localeCompare(b.firstname.toLowerCase()),
        },
        {
            title: 'Payment Amount',
            dataIndex: 'amount',
            key: 'amount',
            render: (val, record, index) => {
                return `$ ${val}`
            },
            sorter: (a, b) => a.amount - b.amount,
        },
        {
            title: 'Account',
            dataIndex: 'accountName',
            key: 'accountName',
            sorter: (a, b) => a.accountName.toLowerCase().localeCompare(b.accountName.toLowerCase()),
        },
        {
            title: 'Recorded By',
            dataIndex: 'username',
            key: 'username',
            sorter: (a, b) => a.username.toLowerCase().localeCompare(b.username.toLowerCase()),
        },
        {
            title: 'Time',
            dataIndex: 'timestamp',
            key: 'timestamp',
            render: (val, record, index) => {
                return toFSDateTime(new Date(val));
            },
            sorter: (a, b) => (new Date(a))- (new Date(b)),
        },
        {
            title: 'Notes',
            dataIndex: 'notes',
            key: 'notes',
            width: 200,
        },
        {
            title: 'Verify',
            dataIndex: 'id',
            key: 'verify',
            render: (val, record, index) => {
                return <Button onClick={onVerify(record)}>Verify</Button>
            }
        },
        {
            title: 'Invalid',
            dataIndex: 'id',
            key: 'invalid',
            render: (val, record, index) => {
                return <Button onClick={onInvalid(record)}>Invalid</Button>
            }
        }
    ];

    const onVerify = (record) => () => {
        verifyPayment(record.id).then(r => {
            if (onRefresh) onRefresh();
            messageApi.open({
                type: 'success',
                content: `Payment Verified`
            })
        }).catch (e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
            messageApi.open({
                type: 'error',
                content: 'Failed to verify Payment'
            })
        })
    }

    const onInvalid = (record) => () => {
        invalidatePayment(record.id).then(r => {
            if (onRefresh) onRefresh();
            messageApi.open({
                type: 'success',
                content: `Payment Invalidated`
            })
        }).catch (e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
            messageApi.open({
                type: 'error',
                content: 'Failed to Invalidate Payment'
            })
        })
    }

    return <div>
        {contextHolder}
        <Table dataSource={payments} columns={columns} />
    </div>
}